"use client"
import React, { useState, useEffect } from "react";
import Header from "@/components/shared/Header";
import FlashMessages from "@/components/shared/FlashMessages";

import "@/components/shared/PageContainer.css";
import { useConfig } from "@/lib/providers/ConfigProvider";
import useUtils from "@/components/shared/useUtils";

const PageContainer = ({
  name,
  profile,
  children,
  fixedPage,
  fixed2Column,
  stickyHeader,
  stickyMap,
  showHeader = true,
  noFooter,
  branded,
  style,
  renderBackButton = true,
  onboarding,
  type = "landing_page"
}) => {
  const { apiUrl, webUrl } = useConfig();
  const utils = useUtils();

  const [renderBack, setRenderBack] = useState(false);

  useEffect(() => {
    if (name && branded) {
      utils.loadDynamicCss(
        `${apiUrl}/api/profiles/${name}/community/${type}.css`
      );
    }
  }, [name, branded]);

  useEffect(() => {
    setRenderBack(
      renderBackButton &&
        window &&
        window.history &&
        window.location &&
        window.history.length > 1 &&
        window.location.pathname !== "/"
    );
    setRenderBack(false);
  }, [renderBackButton]);

  return (
    <div
      className={`main-container${fixedPage ? " fixed-page" : ""}
      ${fixed2Column ? " fixed-2-column" : ""}
        stickyMap ? " sticky-map" : ""
      }${noFooter ? " no-footer" : ""}${branded ? " branded" : ""}${
        stickyHeader ? " sticky-header" : ""
      }`}
      style={style ?? null}
    >
      {showHeader && (
        <Header
          name={name}
          profile={profile}
          branded={branded}
          onboarding={onboarding}
        />
      )}
      <FlashMessages />
      {renderBack && (
        <div className="back-bar">
          <a className="with-icon" href={`${webUrl}${name}`}>
            <span className="material-icons">chevron_left</span>
            <span>Back</span>
          </a>
        </div>
      )}
      {children}
    </div>
  );
};
export default PageContainer;
